import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Link, Text, useColorModeValue } from '@chakra-ui/react';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type React from 'react';

interface IProps {
  readonly href: string;
  readonly icon: IconProp;
  readonly text: string;
  readonly onItemSelected?: () => void;
}

export function SidebarLinkItem(props: React.PropsWithChildren<IProps>) {
  return (
    <Link
      _activeLink={{
        bg: useColorModeValue('gray.700', 'gray.900'),
        color: useColorModeValue('white', 'gray.200'),
      }}
      _hover={{
        bg: useColorModeValue('gray.700', 'gray.900'),
        color: useColorModeValue('white', 'gray.200'),
      }}
      alignItems="center"
      color={useColorModeValue('gray.500', 'gray.400')}
      cursor="pointer"
      display="flex"
      fontWeight="bold"
      href={props.href}
      isExternal
      onClick={props.onItemSelected}
      px={6}
      py={4}
    >
      <FontAwesomeIcon icon={props.icon} size="lg" width={20} />
      <Text pl={2}>
        {props.text} <ExternalLinkIcon mx="2px" />
      </Text>
    </Link>
  );
}
